import { render, staticRenderFns } from "./ItemsCrud.vue?vue&type=template&id=6963b3c1&scoped=true"
import script from "./ItemsCrud.vue?vue&type=script&lang=js"
export * from "./ItemsCrud.vue?vue&type=script&lang=js"
import style0 from "./ItemsCrud.vue?vue&type=style&index=0&id=6963b3c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963b3c1",
  null
  
)

export default component.exports